<template>
	<inline-dialog
		title="Add from LawDepot"
		dialog-class="openExistingDocsDialog"
		width="600"
		class="moveDialogContents MoveDialog vueDialog addExisting sideBySide"
		:state="dialogState"
	>
		<div class="createMoveSelection">
			<p class="prompt">
				Select the document you would like to notarize.
			</p>
			<dialog-bread-crumbs :current-folder="currentFolder" :nav-items="navItems" @change-folder="changeFolder" />
			<div class="myDocsFolderList">
				<slate-loader v-if="isLoading" />
				<div v-if="numberOfDocs > 0 && numberOfDocs > notaryInProgress">
					<folder-small
						v-for="obj in folders"
						:key="obj.ItemId"
						class="itemTileSmall folderTileSmall"
						:item="obj"
						@change-folder="changeFolder"
					/>
					<document-small
						v-for="obj in documents"
						:key="obj.ItemId || obj.Blob?.Identifier || obj.NotarySessionId"
						class="itemTileSmall cbq"
						:item="obj"
						@select-document="selectDocument"
					/>
				</div>
				<div v-else class="myDocsEmpty">
					<div class="emptyIcon" />
					<p>{{ emptyText }}</p>
				</div>
			</div>
		</div>
		<template #buttons="{ closeDialog }">
			<a :class="['largeActiveButton', 'btn-left', {'ui-state-disabled':nothingSelected}]" @click="addToNotarize();closeDialog()">Add To Notarize</a>
			<a class="largeInactiveButton btn-right" @click="closeDialog">Cancel</a>
		</template>
	</inline-dialog>
</template>
<script>
import DialogBreadCrumbs from "./DialogBreadCrumbs.vue";
import FolderSmall from "./FolderSmall.vue";
import DocumentSmall from "./DocumentSmall.vue";
import InlineDialog from "../../components/ui/InlineDialog.vue";
import SlateLoader from "../../components/ui/SlateLoader.vue";
import API from "@ado/notarization-vue-common/src/API/API.js";
import { useSlateLoader } from "@ado/notarization-vue-common/src/composables/slateLoader.js";
import { mapGetters, mapState } from "vuex";

const ItemTileServiceAPI = new API(
	`${window.location.origin}/ItemTileService/API`
);

function getFolderTiles() {
	return ItemTileServiceAPI.GET(`/FolderTile`).then(data => {
		if (data.Status && data.Status == `SignedOut`) {
			window.location.replace(`${window.location.origin}`);
		}
		return data;
	});
}

const selectExistingDialog = {
	components: {
		DialogBreadCrumbs,
		FolderSmall,
		DocumentSmall,
		InlineDialog,
		SlateLoader,
	},
	setup() {
		const { isLoading, startLoading, stopLoading } = useSlateLoader();

		return {
			isLoading,
			startLoading,
			stopLoading,
		};
	},
	emits: [`addToNotarize`],
	data() {
		return {
			items: null,
			currentFolder: null,
			navItems: [],
			selectedDocuments: [],
			selectedDocumentElement: null,
			dialogState: `showExistingDialog`,
		};
	},
	watch: {
		show(newValue) {
			if (newValue) {
				this.loadTiles();
			} else {
				this.items = null;
				this.currentFolder = null;
				this.selectedDocuments = [];
				this.selectedDocumentElement = null;
			}
		},
	},
	computed: {
		show() {
			return this.$store.state[this.dialogState];
		},
		folders() {
			return this.currentFolder?.Children?.filter(
				(child) => child.TileType === `Folder`
			);
		},
		documents() {
			return this.currentFolder?.Children?.filter(
				(child) => child.TileType === `Document` 
			);
		},
		notaryInProgress() {
			return this.currentFolder?.Children?.filter(
				(child) => child.ProductName === `Online Notary`
			).length;
		},
		numberOfDocs() {
			return this.currentFolder?.Children?.length;
		},
		emptyText: function () {
			return `${this.currentFolder?.Name || `My Documents`} is empty`;
		},
		nothingSelected() {
			return this.selectedDocuments.length === 0;
		},
		...mapGetters([`acceptParagraph`]),
		...mapState([`notarizationDocuments`]),
	},
	methods: {
		addToNotarize() {
			this.$emit(`addToNotarize`, this.selectedDocuments);
		},
		loadTiles() {
			this.startLoading();
			getFolderTiles().then((response) => {
				const data = response.Data;
				this.items = data;
				this.currentFolder = data;
				this.stopLoading();
			});
		},
		changeFolder: function (folder) {
			const ref = this.items;

			if (isNaN(folder)) {
				this.currentFolder = folder;
			} else {
				this.currentFolder = this.getFolder(ref, folder);
			}

			let obj = this.currentFolder;
			this.navItems.splice(0, this.navItems.length);
			while (obj) {
				this.navItems.push({
					name: obj.Name,
					id: obj.ItemId,
				});
				obj = obj.Parent;
			}
		},
		getFolder: function (ref, id) {
			const folder = getRef(ref, id);

			function getRef(ref, id) {
				if (ref.ItemId == id) {
					return ref;
				} else {
					for (let i = 0; i < ref.Children.length; i++) {
						const child = ref.Children[i];
						const retVal = getRef(child, id);
						if (retVal != null) {
							return retVal;
						}
					}
				}
			}

			return folder;
		},
		selectDocument(item) {
			let allSelected = this.notarizationDocuments.length + this.selectedDocuments.length;
			if (this.selectedDocuments.length < 5
				&& allSelected < 5
				&& item.isSelected != true) {
				item.isSelected = true;
				this.selectedDocuments.push(item);
			} else if (item.isSelected == true) {
				item.isSelected = false;
				let index = this.selectedDocuments.indexOf(item);
				if (index > -1) {
					this.selectedDocuments.splice(index, 1);
				}				
			}
		},
	},
};

export default selectExistingDialog;
</script> 